// Custom GA4 event hooks for Shopify Customer Events
// Add this file as assets/custom-ga4-events.js
// Load once in theme.liquid with:
// {{ 'custom-ga4-events.js' | asset_url | script_tag }}

(function () {
  'use strict';

  var DEBUG = true;
  var VIEW_THRESHOLD = 0.35;
  var VIEW_MIN_MS = 300;

  var viewedSections = {};
  var fieldInteractionCache = {};
  var cartDrawerViewed = false;

  function log() {
    if (DEBUG && window.console && typeof window.console.log === 'function') {
      window.console.log.apply(window.console, arguments);
    }
  }

  function warn() {
    if (DEBUG && window.console && typeof window.console.warn === 'function') {
      window.console.warn.apply(window.console, arguments);
    }
  }

  function sanitize(value, maxLength) {
    if (value === null || value === undefined) return '';
    var out = String(value).replace(/\s+/g, ' ').trim();
    return out.length > (maxLength || 180) ? out.slice(0, maxLength || 180) : out;
  }

  function text(el, fallback) {
    if (!el) return fallback || '';
    return sanitize(
      el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('title')) ||
      el.textContent ||
      fallback ||
      ''
    );
  }

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function matches(el, selector) {
    return el && el.matches ? el.matches(selector) : false;
  }

  function absoluteUrl(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).href;
    } catch (e) {
      return url;
    }
  }

  function hrefData(el) {
    var link = closest(el, 'a[href]') || (el && matches(el, 'a[href]') ? el : null);
    var href = link ? link.getAttribute('href') : '';

    return {
      element_url: href || '',
      element_url_full: absoluteUrl(href || '')
    };
  }

  function indexIn(selector, el, root) {
    root = root || document;
    if (!el) return '';

    var list = Array.prototype.slice.call(root.querySelectorAll(selector));
    var i = list.indexOf(el);

    return i >= 0 ? i + 1 : '';
  }

  function getSection(el) {
    return closest(el, '.shopify-section.c-section') ||
      closest(el, '.shopify-section') ||
      closest(el, 'section') ||
      null;
  }

  function getSectionType(section) {
    if (!section) return '';

    var cls = String(section.className || '');
    var m = cls.match(/c-section__([a-z0-9-]+)/i);

    if (m && m[1]) return m[1].replace(/-/g, '_');

    var sectionEl = section.matches && section.matches('section')
      ? section
      : section.querySelector('section[class]');

    if (sectionEl) {
      var m2 = String(sectionEl.className || '').match(/c-([a-z0-9-]+)/i);
      if (m2 && m2[1]) return m2[1].replace(/-/g, '_');
    }

    return '';
  }

  function titleFromSection(section) {
    if (!section) return '';

    var heading = section.querySelector('h1, h2, h3, [class*="__title"], [aria-label]');
    return text(heading, getSectionType(section));
  }

  function sectionPayload(el) {
    var section = getSection(el);

    return {
      section_name: titleFromSection(section),
      section_type: getSectionType(section),
      section_id: section ? section.id || '' : ''
    };
  }

  function pageType() {
    if (document.body.classList.contains('c-page--product')) return 'product';
    if (document.body.classList.contains('c-page--collection')) return 'collection';
    if (document.body.classList.contains('c-page--blog')) return 'blog';
    if (document.body.classList.contains('c-page--article')) return 'article';
    if (document.body.classList.contains('c-page--page') && window.location.pathname.indexOf('/pages/about-us') > -1) return 'about';
    if (window.location.pathname === '/' || window.location.pathname === '') return 'homepage';
    return '';
  }

  function basePayload(el, extra) {
    var data = {
      event_category: 'engagement',
      page_type: pageType(),
      page_path: window.location.pathname,
      page_location: window.location.href,
      page_title: document.title,
      viewport_width: window.innerWidth || '',
      viewport_height: window.innerHeight || ''
    };

    var section = sectionPayload(el || document.body);

    for (var s in section) data[s] = section[s];
    for (var k in (extra || {})) data[k] = extra[k];

    if (!data.event_label) {
      data.event_label = data.element_text || data.element_action || data.section_name || '';
    }

    return data;
  }

  function publish(eventName, payload, sourceEl) {
    var data = basePayload(sourceEl, payload);

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      log('[GA4 custom events] Publishing:', eventName, data);
      window.Shopify.analytics.publish(eventName, data);
      return true;
    }

    warn('[GA4 custom events] Shopify.analytics.publish unavailable:', eventName, data);
    return false;
  }

  function controlAction(el) {
    var label = text(el).toLowerCase();
    var cls = String(el.className || '').toLowerCase();

    if (/previous|prev|left/.test(label + ' ' + cls)) return 'previous';
    if (/next|right/.test(label + ' ' + cls)) return 'next';
    if (/pause|play/.test(label + ' ' + cls)) return 'play_pause';
    if (/mute|sound|volume/.test(label + ' ' + cls)) return 'mute_sound';
    if (/close/.test(label + ' ' + cls)) return 'close';
    if (/open/.test(label + ' ' + cls)) return 'open';

    return label || 'control';
  }

  function productCard(el) {
    return closest(
      el,
      '.o-product-thumbnail, .o-product-card, [data-product-card], .rebuy-product-block, .c-testimonials__product, .c-shop-the-look__pin-product-card'
    );
  }

  function productName(card) {
    return text(
      card &&
        card.querySelector(
          '.o-product-thumbnail__title, .o-product-card__title, .rebuy-product-title-link, .rebuy-product-title, .c-testimonials__product-title, [class*="product-title"], [data-product-title]'
        )
    );
  }

  function productPayload(target) {
    var card = productCard(target);
    var link = closest(target, 'a[href]');
    var addBtn = closest(
      target,
      '[data-product-quick-add], .o-product-thumbnail__add-btn, .o-product-card__add, .rebuy-button, button[name="add"], form[action*="/cart/add"] button[type="submit"]'
    );
    var swatch = closest(target, '.o-product-thumbnail__shade-swatch, [class*="swatch"], [data-variant-id]');
    var image = closest(target, '.o-product-thumbnail__image, .o-product-thumbnail__image-area-link, .o-product-card__image, .rebuy-product-media, img');
    var title = closest(target, '.o-product-thumbnail__title, .o-product-card__title, .rebuy-product-title-link, [class*="product-title"]');

    var elementType = 'product_card';

    if (addBtn) elementType = 'add_to_cart';
    else if (swatch) elementType = 'variant_swatch';
    else if (title) elementType = 'title';
    else if (image) elementType = 'image';
    else if (link) elementType = 'product_link';

    var productUrl = link ? link.getAttribute('href') : '';

    return {
      element_type: elementType,
      element_text: text(addBtn || swatch || title || link || card, productName(card)),
      element_url: productUrl,
      element_url_full: absoluteUrl(productUrl),
      item_name: productName(card),
      item_id:
        (addBtn && addBtn.getAttribute('data-product-id')) ||
        (card && card.getAttribute('data-product-id')) ||
        '',
      item_variant:
        (swatch &&
          (swatch.getAttribute('data-variant-id') ||
            swatch.getAttribute('value') ||
            swatch.getAttribute('aria-label'))) ||
        (addBtn && addBtn.getAttribute('data-variant-id')) ||
        '',
      item_position: card
        ? indexIn(
            '.o-product-thumbnail, .o-product-card, [data-product-card], .rebuy-product-block, .c-testimonials__product, .c-shop-the-look__pin-product-card',
            card,
            getSection(card) || document
          )
        : ''
    };
  }

  function getShopifyMeta() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return meta || {};
  }

  function getCollectionMeta() {
    var meta = getShopifyMeta();
    var page = meta.page || {};

    return {
      collection_name: document.querySelector('h1') ? text(document.querySelector('h1')) : '',
      collection_id: page.resourceId ? String(page.resourceId) : ''
    };
  }

  function getProductMeta() {
    var meta = getShopifyMeta();
    var product = meta.product;
    var variant = product && product.variants && product.variants[0];

    return {
      item_name:
        (variant && variant.name) ||
        (document.querySelector('.c-product-main__title, h1') ? text(document.querySelector('.c-product-main__title, h1')) : ''),
      item_id: product && product.id ? String(product.id) : '',
      item_variant: variant && variant.id ? String(variant.id) : '',
      item_price: variant && variant.price ? String(variant.price / 100) : '',
      item_category: product && product.type ? product.type : ''
    };
  }

  function getArticleMeta() {
    var meta = getShopifyMeta();
    var page = meta.page || {};

    return {
      article_title: document.querySelector('.c-article-hero__title, h1') ? text(document.querySelector('.c-article-hero__title, h1')) : document.title,
      article_id: page.resourceId ? String(page.resourceId) : '',
      article_category: document.querySelector('.c-article-hero__tag') ? text(document.querySelector('.c-article-hero__tag')) : ''
    };
  }

  function getBlogMeta() {
    var meta = getShopifyMeta();
    var page = meta.page || {};

    return {
      blog_name: document.querySelector('h1') ? text(document.querySelector('h1')) : document.title,
      blog_id: page.resourceId ? String(page.resourceId) : ''
    };
  }

  function merge(a, b) {
    var out = {};
    var k;

    for (k in (a || {})) out[k] = a[k];
    for (k in (b || {})) out[k] = b[k];

    return out;
  }

  function addMetaForPage(payload) {
    if (pageType() === 'collection') return merge(getCollectionMeta(), payload);
    if (pageType() === 'product') return merge(getProductMeta(), payload);
    if (pageType() === 'blog') return merge(getBlogMeta(), payload);
    if (pageType() === 'article') return merge(getArticleMeta(), payload);
    return payload;
  }

  function publishWithPageMeta(eventName, payload, el) {
    publish(eventName, addMetaForPage(payload || {}), el);
  }

  function getQuantity() {
    var qty = document.querySelector('.c-product-form__qty input, input[name="quantity"], [data-quantity-input]');
    return qty ? qty.value || qty.getAttribute('value') || '' : '';
  }

  function getFilterName(el) {
    var group = closest(el, 'details, .c-filter, .c-filters__group, .c-filter-drawer__group, [data-filter-group]');
    var label = group && group.querySelector('summary, .c-filter__title, .c-filters__title, [data-filter-title]');
    return text(label || group || el);
  }

  function articleCard(el) {
    return closest(el, '.c-home-featured-journal__article, .c-featured-blog-tile, .c-related-articles article, .c-related-articles__item');
  }

  function articlePayload(el) {
    var card = articleCard(el);
    var link = closest(el, 'a[href]') || (card && card.querySelector('a[href]'));
    var href = link ? link.getAttribute('href') : '';

    return {
      element_text: text(el) || text(card),
      element_url: href || '',
      element_url_full: absoluteUrl(href || ''),
      article_title: text(card && card.querySelector('.c-home-featured-journal__article-title, .c-featured-blog-tile__article-title, [class*="article-title"]')),
      article_category: text(card && card.querySelector('.c-home-featured-journal__article-category, .c-featured-blog-tile__article-badge, [class*="article-category"]')),
      article_author: text(card && card.querySelector('.c-home-featured-journal__article-author, .c-featured-blog-tile__article-author')),
      article_date: text(card && card.querySelector('.c-home-featured-journal__article-date, .c-featured-blog-tile__article-date')),
      article_position: card
        ? indexIn(
            '.c-home-featured-journal__article, .c-featured-blog-tile, .c-related-articles article, .c-related-articles__item',
            card,
            getSection(card) || document
          )
        : ''
    };
  }

  function articleClickType(el) {
    if (closest(el, 'picture, img, [class*="image"]')) return 'image';
    if (closest(el, '[class*="title"]')) return 'title';
    if (closest(el, '[class*="category"], [class*="badge"]')) return 'category';
    if (closest(el, '[class*="metadata"], [class*="date"], [class*="author"]')) return 'metadata';
    return 'article_link';
  }

  function getCartDrawer() {
    return document.querySelector('#rebuy-cart');
  }

  function isCartDrawerVisible(cart) {
    if (!cart) return false;

    return (
      cart.classList.contains('is-visible') ||
      cart.getAttribute('aria-hidden') === 'false' ||
      cart.style.visibility === 'visible'
    );
  }

  function getCartItemCount(cart) {
    cart = cart || getCartDrawer();

    var title = cart && cart.querySelector('#SmartCart_title, .rebuy-cart__flyout-title');
    var match = title ? text(title).match(/\((\d+)\)/) : null;

    return match ? match[1] : '';
  }

  function getCartSubtotal(cart) {
    cart = cart || getCartDrawer();

    var subtotal = cart && cart.querySelector('.rebuy-cart__flyout-subtotal-amount');

    return subtotal ? text(subtotal).replace(/[^\d.,]/g, '') : '';
  }

  function cartBase(extra) {
    var cart = getCartDrawer();
    var payload = extra || {};

    payload.cart_item_count = payload.cart_item_count || getCartItemCount(cart);
    payload.cart_subtotal = payload.cart_subtotal || getCartSubtotal(cart);
    payload.section_name = payload.section_name || 'Cart drawer';
    payload.section_type = payload.section_type || 'cart_drawer';

    return payload;
  }

  function getCartLineItem(el) {
    return closest(el, '.rebuy-cart__flyout-item');
  }

  function getCartLineItemName(item) {
    return text(item && item.querySelector('.rebuy-cart__flyout-item-product-title'));
  }

  function getCartLineItemPayload(el) {
    var item = getCartLineItem(el);
    var link = closest(el, 'a[href]') || (item && item.querySelector('a[href]'));
    var href = link ? link.getAttribute('href') : '';

    return cartBase({
      element_text: text(el) || getCartLineItemName(item),
      element_url: href || '',
      element_url_full: absoluteUrl(href || ''),
      item_name: getCartLineItemName(item),
      item_id: item ? ((String(item.className || '').match(/product-id-(\d+)/) || [])[1] || '') : '',
      item_variant: '',
      item_position: item
        ? indexIn('.rebuy-cart__flyout-item', item, closest(item, '.rebuy-cart__flyout-items') || document)
        : '',
      quantity: text(item && item.querySelector('.rebuy-cart__flyout-item-quantity-widget-label')).replace(/[^\d]/g, '')
    });
  }

  function publishCartViewedIfVisible() {
    var cart = getCartDrawer();

    if (!cart || cartDrawerViewed || !isCartDrawerVisible(cart)) return;

    cartDrawerViewed = true;

    publish(
      'cart_drawer_viewed',
      cartBase({
        element_type: 'drawer',
        element_action: 'view'
      }),
      cart
    );
  }

  function handleHomepageClick(target) {
    var promoPause = closest(target, '.c-promo-banner [data-promo-pause]');
    if (promoPause) {
      publish('announcement_bar_control_clicked', {
        element_type: 'control',
        element_action: 'play_pause',
        element_text: text(promoPause),
        container_name: text(document.querySelector('.c-promo-banner__message.is-active'))
      }, promoPause);
      return true;
    }

    var promoLink = closest(target, '.c-promo-banner a[href]');
    if (promoLink) {
      var isTopBarNavLink = !!closest(promoLink, '.c-promo-banner__nav');

      publish(isTopBarNavLink ? 'top_bar_link_clicked' : 'announcement_bar_link_clicked', merge({
        element_type: 'link',
        element_text: text(promoLink),
        element_position: indexIn('.c-promo-banner a[href]', promoLink, closest(promoLink, '.c-promo-banner') || document),
        container_name: isTopBarNavLink ? text(closest(promoLink, '.c-promo-banner__nav')) : text(closest(promoLink, '.c-promo-banner__message'))
      }, hrefData(promoLink)), promoLink);

      return true;
    }

    var headerIcon = closest(
      target,
      '.c-header__link, .c-header__logo, .c-main-menu__additional-link, [data-search-toggle], [data-menu-toggle], [href="/cart"], [href="/account"]'
    );
    if (headerIcon && closest(headerIcon, '.c-header')) {
      publish('header_icon_clicked', merge({
        element_type: 'icon',
        element_text: text(headerIcon),
        element_action:
          headerIcon.getAttribute('data-search-toggle') !== null
            ? 'search'
            : headerIcon.getAttribute('data-menu-toggle') !== null
              ? 'menu'
              : text(headerIcon)
      }, hrefData(headerIcon)), headerIcon);
      return true;
    }

    var mainMenu = closest(target, '.c-main-menu');
    if (mainMenu) {
      var menuAccordion = closest(target, '.c-main-menu__accordion-header, [data-accordion-title]');
      if (menuAccordion) {
        publish('megamenu_item_clicked', {
          element_type: 'accordion',
          element_action: closest(menuAccordion, 'details') && closest(menuAccordion, 'details').open ? 'collapse' : 'expand',
          element_text: text(menuAccordion),
          container_name: text(closest(menuAccordion, '.c-main-menu__list-wrap')),
          container_type: 'main_menu'
        }, menuAccordion);
        return true;
      }

      var menuLink = closest(target, '.c-main-menu a[href], .c-main-menu button');
      if (menuLink) {
        var isMega = !matches(menuLink, '.c-main-menu__link.is-level-1');

        publish(isMega ? 'megamenu_item_clicked' : 'navigation_menu_clicked', merge({
          element_type: matches(menuLink, 'button') ? 'button' : 'link',
          element_text: text(menuLink),
          element_position: indexIn('.c-main-menu a, .c-main-menu button', menuLink, mainMenu),
          container_name: text(closest(menuLink, '.c-main-menu__list-wrap')),
          container_type: 'main_menu'
        }, hrefData(menuLink)), menuLink);
        return true;
      }
    }

    var heroBtn = closest(target, '.c-hero-banner-carousel__btn');
    if (heroBtn) {
      var slide = closest(heroBtn, '.c-hero-banner-carousel__item');

      publish('homepage_carousel_cta_clicked', merge({
        element_type: 'cta',
        element_text: text(heroBtn),
        element_position: indexIn('.c-hero-banner-carousel__item', slide, slide && slide.parentElement),
        section_name: 'Homepage hero carousel',
        section_type: 'hero_banner_carousel',
        container_name: text(slide && slide.querySelector('.c-hero-banner-carousel__title')),
        container_description: text(slide && slide.querySelector('.c-hero-banner-carousel__description')),
        container_is_active: slide ? slide.classList.contains('is-active') : false
      }, hrefData(heroBtn)), heroBtn);
      return true;
    }

    var heroControl = closest(
      target,
      '.c-hero-banner-carousel__controls button, .c-hero-banner-carousel__dot, .c-hero-banner-carousel [data-carousel-prev], .c-hero-banner-carousel [data-carousel-next], .c-hero-banner-carousel [data-control]'
    );
    if (heroControl) {
      publish('summer_carousel_control_clicked', {
        element_type: 'control',
        element_action: controlAction(heroControl),
        element_text: text(heroControl),
        element_position: indexIn('.c-hero-banner-carousel__controls button, .c-hero-banner-carousel__dot', heroControl, closest(heroControl, '.c-hero-banner-carousel') || document),
        container_name: titleFromSection(getSection(heroControl))
      }, heroControl);
      return true;
    }

    var findGlow = closest(target, '.c-mission-statement__btn');
    if (findGlow) {
      publish('find_your_glow_cta_clicked', merge({
        element_type: 'cta',
        element_text: text(findGlow),
        container_name: titleFromSection(getSection(findGlow))
      }, hrefData(findGlow)), findGlow);
      return true;
    }

    var collectionLink = closest(target, '.c-home-featured-collection a[href]');
    if (collectionLink) {
      publish('collection_section_clicked', merge({
        element_type: target.tagName && target.tagName.toLowerCase() === 'img' ? 'image' : 'link',
        element_text: text(collectionLink),
        element_position: indexIn('.c-home-featured-collection a[href]', collectionLink, closest(collectionLink, '.c-home-featured-collection') || document),
        container_name: titleFromSection(getSection(collectionLink))
      }, hrefData(collectionLink)), collectionLink);
      return true;
    }

    return false;
  }

  function handleProductCarouselClick(target) {
    var productCarousel = closest(target, '.c-product-carousel');
    if (!productCarousel) return false;

    var toggle = closest(target, '.c-product-carousel .c-categories__btn');
    if (toggle) {
      publish('product_carousel_toggle_clicked', {
        element_type: 'toggle',
        element_action: 'select_tab',
        element_text: text(toggle),
        element_position: indexIn('.c-product-carousel .c-categories__btn', toggle, productCarousel),
        container_type: 'product_carousel',
        container_name: titleFromSection(getSection(toggle))
      }, toggle);
      return true;
    }

    var nav = closest(target, '.c-product-carousel__nav-button, .c-product-carousel [data-carousel-prev], .c-product-carousel [data-carousel-next]');
    if (nav) {
      publish('product_carousel_clicked', {
        element_type: 'control',
        element_action: controlAction(nav),
        element_text: text(nav),
        container_type: 'product_carousel'
      }, nav);
      return true;
    }

    var add = closest(
      target,
      '.c-product-carousel [data-product-quick-add], .c-product-carousel .o-product-thumbnail__add-btn, .c-product-carousel button[name="add"], .c-product-carousel form[action*="/cart/add"] button[type="submit"]'
    );
    if (add) {
      publish('product_carousel_add_to_cart_clicked', productPayload(add), add);
      return true;
    }

    var interaction = closest(target, '.c-product-carousel a[href], .c-product-carousel .o-product-thumbnail__shade-swatch, .c-product-carousel [class*="swatch"]');
    if (interaction) {
      publish('product_carousel_clicked', productPayload(interaction), interaction);
      return true;
    }

    return false;
  }

  function handleProductInsertClick(target) {
    var shopLook = closest(target, '.c-shop-the-look');
    if (!shopLook) return false;

    var toggle = closest(target, '.c-shop-the-look .c-categories__btn, .c-shop-the-look [data-shop-the-look-pin]');
    if (toggle) {
      publish('product_insert_toggle_clicked', {
        element_type: closest(toggle, '[data-shop-the-look-pin]') ? 'pin' : 'toggle',
        element_action: 'open_product_insert',
        element_text: text(toggle),
        element_position: indexIn('.c-shop-the-look .c-categories__btn, .c-shop-the-look [data-shop-the-look-pin]', toggle, shopLook),
        item_id: toggle.getAttribute('data-pin-product-for') || toggle.getAttribute('data-category-id') || ''
      }, toggle);
      return true;
    }

    var add = closest(target, '.c-shop-the-look [data-product-quick-add], .c-shop-the-look .o-product-card__add');
    if (add) {
      publish('product_insert_add_to_cart_clicked', productPayload(add), add);
      return true;
    }

    var link = closest(target, '.c-shop-the-look .o-product-card__link, .c-shop-the-look a[href]');
    if (link) {
      publish('product_insert_product_link_clicked', productPayload(link), link);
      return true;
    }

    publish('product_insert_section_clicked', {
      element_type: 'section',
      element_text: text(target)
    }, target);
    return true;
  }

  function handleVideoAndBlogHomepageClick(target) {
    var glowAccordion = closest(target, '.c-text-image__accordion-header');
    if (glowAccordion) {
      var details = closest(glowAccordion, 'details');

      publish('glow_experts_accordion_clicked', {
        element_type: 'accordion',
        element_action: details && details.open ? 'collapse' : 'expand',
        element_text: text(glowAccordion),
        container_name: 'The Glow Experts'
      }, glowAccordion);
      return true;
    }

    var glowLink = closest(target, '.c-text-image a[href]');
    if (glowLink) {
      publish('glow_experts_link_clicked', merge({
        element_type: 'link',
        element_text: text(glowLink),
        container_name: 'The Glow Experts'
      }, hrefData(glowLink)), glowLink);
      return true;
    }

    var textControl = closest(target, '.c-text-image [data-control], .c-text-image button');
    if (textControl) {
      publish('summer_round_carousel_control_clicked', {
        element_type: 'control',
        element_action: controlAction(textControl),
        element_text: text(textControl),
        container_name: titleFromSection(getSection(textControl))
      }, textControl);
      return true;
    }

    var testimonials = closest(target, '.c-testimonials');
    if (testimonials) {
      var testimonialTab = closest(target, '.c-testimonials .c-categories__btn');
      if (testimonialTab) {
        publish(pageType() === 'about' ? 'about_testimonial_tab_clicked' : 'video_carousel_glowing_results_clicked', {
          element_type: 'toggle',
          element_action: 'select_tab',
          element_text: text(testimonialTab),
          element_position: indexIn('.c-testimonials .c-categories__btn', testimonialTab, testimonials),
          container_name: pageType() === 'about' ? 'Our Glow Getters' : titleFromSection(getSection(testimonialTab)),
          container_type: 'video_carousel'
        }, testimonialTab);
        return true;
      }

      var testimonialControl = closest(
        target,
        '.c-testimonials__nav-button, .c-testimonials [data-carousel-prev], .c-testimonials [data-carousel-next], .c-testimonials__video-button, .c-testimonials [data-video-pointer-toggle]'
      );
      if (testimonialControl) {
        publish(pageType() === 'about' ? 'about_testimonial_video_interacted' : 'video_carousel_control_clicked', {
          element_type: 'control',
          element_action: controlAction(testimonialControl),
          element_text: text(testimonialControl),
          element_position: indexIn('.c-testimonials__nav-button, .c-testimonials__video-button, .c-testimonials [data-video-pointer-toggle]', testimonialControl, testimonials),
          container_name: pageType() === 'about' ? 'Our Glow Getters' : titleFromSection(getSection(testimonialControl))
        }, testimonialControl);
        return true;
      }

      var testimonialProduct = closest(target, '.c-testimonials__product-link, .c-testimonials__product a[href]');
      if (testimonialProduct) {
        var tp = productPayload(testimonialProduct);
        tp.container_name = pageType() === 'about' ? 'Our Glow Getters' : titleFromSection(getSection(testimonialProduct));

        publish(pageType() === 'about' ? 'about_testimonial_product_clicked' : 'video_carousel_product_link_clicked', tp, testimonialProduct);
        return true;
      }
    }

    var videoControl = closest(target, '.c-video [data-control], .c-video__control-button, .c-video [data-video-pointer-toggle]');
    if (videoControl) {
      publish(pageType() === 'about' ? 'about_video_interacted' : 'video_section_control_clicked', {
        element_type: 'control',
        element_action: controlAction(videoControl),
        element_text: text(videoControl),
        container_name: titleFromSection(getSection(videoControl))
      }, videoControl);
      return true;
    }

    var blogSection = closest(target, '.c-home-featured-journal');
    if (blogSection) {
      var blogToggle = closest(target, '.c-home-featured-journal .c-categories__btn');
      if (blogToggle) {
        publish(pageType() === 'about' ? 'about_blog_tab_clicked' : 'blog_carousel_toggle_clicked', {
          element_type: 'toggle',
          element_action: 'select_tab',
          element_text: text(blogToggle),
          element_position: indexIn('.c-home-featured-journal .c-categories__btn', blogToggle, blogSection),
          container_name: pageType() === 'about' ? 'Glow Tips' : titleFromSection(getSection(blogToggle)),
          container_type: 'blog_carousel'
        }, blogToggle);
        return true;
      }

      var blogControl = closest(target, '.c-home-featured-journal__nav-button, .c-home-featured-journal [data-carousel-prev], .c-home-featured-journal [data-carousel-next]');
      if (blogControl) {
        publish(pageType() === 'about' ? 'about_blog_carousel_control_clicked' : 'blog_carousel_control_clicked', {
          element_type: 'control',
          element_action: controlAction(blogControl),
          element_text: text(blogControl),
          container_name: pageType() === 'about' ? 'Glow Tips' : titleFromSection(getSection(blogControl))
        }, blogControl);
        return true;
      }

      var explore = closest(target, '.c-home-featured-journal__cta');
      if (explore) {
        publish(pageType() === 'about' ? 'about_blog_explore_more_clicked' : 'blog_carousel_explore_more_clicked', merge({
          element_type: 'cta',
          element_text: text(explore),
          container_name: pageType() === 'about' ? 'Glow Tips' : titleFromSection(getSection(explore))
        }, hrefData(explore)), explore);
        return true;
      }

      var blogLink = closest(target, '.c-home-featured-journal__article-link, .c-home-featured-journal a[href]');
      if (blogLink) {
        publish(pageType() === 'about' ? 'about_blog_link_clicked' : 'blog_carousel_link_clicked', merge({
          element_type: closest(blogLink, '.c-home-featured-journal__article-image-container') ? 'image' : 'link',
          element_text: text(blogLink),
          element_position: indexIn('.c-home-featured-journal__article-link, .c-home-featured-journal a[href]', blogLink, blogSection),
          container_name: pageType() === 'about' ? 'Glow Tips' : text(closest(blogLink, '.c-home-featured-journal__article'))
        }, hrefData(blogLink)), blogLink);
        return true;
      }
    }

    return false;
  }

  function handleCollectionClick(target) {
    if (pageType() !== 'collection') return false;

    var readMore = closest(target, '.c-collection-hero__read-more, .c-collection-header__read-more, [data-read-more], [data-collection-read-more]');
    if (readMore) {
      publishWithPageMeta('collection_read_more_clicked', {
        element_type: 'button',
        element_action: /less|collapse|hide/i.test(text(readMore)) ? 'collapse' : 'expand',
        element_text: text(readMore)
      }, readMore);
      return true;
    }

    var allCta = closest(target, '.c-collection-nav a[href], .c-collection-tabs a[href], .c-categories a[href], a[href*="/collections/"]');
    if (allCta && /^all$/i.test(text(allCta).replace(/\s+/g, ' ').trim())) {
      publishWithPageMeta('collection_all_cta_clicked', merge({
        element_type: 'cta',
        element_text: text(allCta),
        element_position: indexIn('a[href]', allCta, getSection(allCta) || document)
      }, hrefData(allCta)), allCta);
      return true;
    }

    var filterByType = closest(target, '[data-filter-by-type], [data-filter-toggle], [data-filters-toggle], .c-collection__filter-button, .c-filters-toggle');
    if (filterByType) {
      publishWithPageMeta('collection_filter_type_clicked', {
        element_type: 'filter_button',
        element_action: 'open',
        element_text: text(filterByType),
        filter_name: text(filterByType) || 'Filter by type'
      }, filterByType);
      return true;
    }

    var sortControl = closest(target, '[name="sort_by"], [data-sort-by], [data-sort-toggle], .c-sort, .c-collection-sort, .c-collection__sort');
    if (sortControl) {
      publishWithPageMeta('collection_sort_by_clicked', {
        element_type: 'sort',
        element_action: matches(sortControl, 'select, option') ? 'select' : 'open',
        element_text: text(sortControl),
        sort_value: sortControl.value || sortControl.getAttribute('data-sort-by') || ''
      }, sortControl);
      return true;
    }

    var drawerOpen = closest(target, '[data-filter-drawer-open], [data-filters-drawer-open], [aria-controls*="filter" i], .c-filter-drawer__open');
    if (drawerOpen) {
      publishWithPageMeta('collection_filters_drawer_opened', {
        element_type: 'drawer',
        element_action: 'open',
        element_text: text(drawerOpen)
      }, drawerOpen);
      return true;
    }

    var drawerClose = closest(target, '[data-filter-drawer-close], [data-filters-drawer-close], .c-filter-drawer__close, .c-drawer__close');
    if (drawerClose) {
      publishWithPageMeta('collection_filters_drawer_closed', {
        element_type: 'drawer',
        element_action: 'close',
        element_text: text(drawerClose)
      }, drawerClose);
      return true;
    }

    var filterGroup = closest(target, '.c-filter summary, .c-filters summary, .c-filter-drawer summary, [data-filter-title], [data-filter-group-toggle]');
    if (filterGroup) {
      var details = closest(filterGroup, 'details');

      publishWithPageMeta('collection_filter_group_toggled', {
        element_type: 'accordion',
        element_action: details && details.open ? 'collapse' : 'expand',
        element_text: text(filterGroup),
        filter_name: getFilterName(filterGroup)
      }, filterGroup);
      return true;
    }

    var filterItem = closest(target, '.c-filter input, .c-filters input, .c-filter-drawer input, .c-filter label, .c-filters label, .c-filter-drawer label, [data-filter-item]');
    if (filterItem) {
      var input = matches(filterItem, 'input') ? filterItem : filterItem.querySelector && filterItem.querySelector('input');

      publishWithPageMeta('collection_filter_item_clicked', {
        element_type: 'filter_item',
        element_action: input && input.checked ? 'select' : 'deselect',
        element_text: text(filterItem),
        filter_name: getFilterName(filterItem),
        filter_value: filterItem.value || filterItem.getAttribute('data-filter-value') || text(filterItem)
      }, filterItem);
      return true;
    }

    var reset = closest(target, '[data-filter-reset], [data-filters-reset], button[type="reset"], a[href*="reset"], a[href*="filter"]');
    if (reset && /reset|clear/i.test(text(reset) + ' ' + reset.getAttribute('href'))) {
      publishWithPageMeta('collection_filters_reset_clicked', {
        element_type: 'reset',
        element_action: 'reset_filters',
        element_text: text(reset)
      }, reset);
      return true;
    }

    var viewItems = closest(target, '[data-filter-submit], [data-view-results], [data-view-items], .c-filter-drawer__submit, .c-filters__submit');
    if (viewItems) {
      publishWithPageMeta('collection_view_items_clicked', {
        element_type: 'button',
        element_action: 'view_items',
        element_text: text(viewItems),
        results_count: (text(viewItems).match(/\d+/) || [''])[0]
      }, viewItems);
      return true;
    }

    var collectionAtc = closest(target, '.c-page--collection [data-product-quick-add], .c-page--collection .o-product-thumbnail__add-btn, .c-page--collection button[name="add"], .c-page--collection form[action*="/cart/add"] button[type="submit"]');
    if (collectionAtc) {
      publishWithPageMeta('collection_product_add_to_cart_clicked', productPayload(collectionAtc), collectionAtc);
      return true;
    }

    var collectionProduct = closest(target, '.c-page--collection .o-product-thumbnail a[href], .c-page--collection .o-product-card a[href], .c-page--collection [data-product-card] a[href], .c-page--collection .o-product-thumbnail__shade-swatch, .c-page--collection [class*="swatch"]');
    if (collectionProduct) {
      publishWithPageMeta('collection_product_clicked', productPayload(collectionProduct), collectionProduct);
      return true;
    }

    var bannerControl = closest(target, '.c-collection-banner [data-carousel-prev], .c-collection-banner [data-carousel-next], .c-collection-banner button, .c-collection-hero [data-carousel-prev], .c-collection-hero [data-carousel-next], .c-collection-hero button');
    if (bannerControl) {
      publishWithPageMeta('collection_banner_control_clicked', {
        element_type: 'control',
        element_action: controlAction(bannerControl),
        element_text: text(bannerControl),
        element_position: indexIn('button, [data-carousel-prev], [data-carousel-next]', bannerControl, getSection(bannerControl) || document),
        container_name: titleFromSection(getSection(bannerControl))
      }, bannerControl);
      return true;
    }

    return false;
  }

  function handleProductPageClick(target) {
    if (pageType() !== 'product') return false;

    var breadcrumb = closest(target, '.c-page--product .c-breadcrumbs__link');
    if (breadcrumb) {
      publishWithPageMeta('product_breadcrumb_clicked', merge({
        element_type: 'breadcrumb',
        element_text: text(breadcrumb),
        element_position: indexIn('.c-breadcrumbs__link', breadcrumb, closest(breadcrumb, '.c-breadcrumbs') || document)
      }, hrefData(breadcrumb)), breadcrumb);
      return true;
    }

    var zoom = closest(target, '.c-product-gallery__zoom-button, [data-pg-zoom], [data-product-zoom]');
    if (zoom) {
      publishWithPageMeta('product_image_zoom_clicked', {
        element_type: 'zoom',
        element_action: document.body.classList.contains('is-product-zoom-open') ? 'zoom_out' : 'zoom_in',
        element_text: text(zoom) || 'Product image zoom'
      }, zoom);
      return true;
    }

    var thumbnail = closest(target, '.c-product-gallery__thumbnail-button, .c-product-gallery__thumbnail-item');
    if (thumbnail) {
      publishWithPageMeta('product_thumbnail_clicked', {
        element_type: 'thumbnail',
        element_text: text(thumbnail) || 'Product thumbnail',
        element_position: indexIn('.c-product-gallery__thumbnail-button, .c-product-gallery__thumbnail-item', thumbnail, closest(thumbnail, '.c-product-gallery') || document),
        media_type: thumbnail.getAttribute('data-media-type') || ''
      }, thumbnail);
      return true;
    }

    var galleryNav = closest(target, '.c-product-gallery [data-carousel-prev], .c-product-gallery [data-carousel-next], .c-product-gallery .o-carousel-control, .c-product-gallery button[aria-label*="Previous" i], .c-product-gallery button[aria-label*="Next" i]');
    if (galleryNav) {
      publishWithPageMeta('product_thumbnails_navigation_clicked', {
        element_type: 'control',
        element_action: controlAction(galleryNav),
        element_text: text(galleryNav)
      }, galleryNav);
      return true;
    }

    var rating = closest(target, '.c-product-main__reviews, .yotpo-widget-instance, [data-bv-show="rating_summary"], [data-bv-show="inline_rating"], a[href*="reviews"], a[href="#reviews"]');
    if (rating && closest(rating, '.c-product-main')) {
      publishWithPageMeta('product_star_rating_clicked', {
        element_type: 'rating',
        element_action: 'scroll_to_reviews',
        element_text: text(rating),
        rating_value: rating.getAttribute('data-rating') || '',
        reviews_count: rating.getAttribute('data-review-count') || ''
      }, rating);
      return true;
    }

    var readMore = closest(target, '.c-product-main__description-button, [data-product-read-more], [data-read-more]');
    if (readMore && closest(readMore, '.c-product-main')) {
      publishWithPageMeta('product_read_more_clicked', {
        element_type: 'button',
        element_action: /less|collapse|hide/i.test(text(readMore)) ? 'collapse' : 'expand',
        element_text: text(readMore)
      }, readMore);
      return true;
    }

    var qtyButton = closest(target, '.c-product-form__qty button, [data-quantity-plus], [data-quantity-minus], .quantity__button, button[name="plus"], button[name="minus"]');
    if (qtyButton && closest(qtyButton, '.c-product-form, .c-product-main')) {
      publishWithPageMeta('product_quantity_clicked', {
        element_type: 'quantity',
        element_action: /minus|decrease|−|-/.test(text(qtyButton).toLowerCase() + ' ' + qtyButton.className) ? 'decrease' : 'increase',
        element_text: text(qtyButton),
        quantity: getQuantity()
      }, qtyButton);
      return true;
    }

    var stickyAtc = closest(target, '.c-sticky-atc__add-to-cart, [data-sa-add]');
    if (stickyAtc) {
      publishWithPageMeta('product_sticky_add_to_cart_clicked', {
        element_type: 'add_to_cart',
        element_action: 'sticky_add_to_cart',
        element_text: text(stickyAtc),
        quantity: getQuantity()
      }, stickyAtc);
      return true;
    }

    var mainAtc = closest(target, '.c-product-form__add-btn, .c-product-main button[name="add"], .c-product-main form[action*="/cart/add"] button[type="submit"]');
    if (mainAtc && !closest(mainAtc, '.c-sticky-atc') && !closest(mainAtc, '.c-product-main__bundle-upsell')) {
      publishWithPageMeta('product_add_to_cart_clicked', {
        element_type: 'add_to_cart',
        element_text: text(mainAtc),
        quantity: getQuantity()
      }, mainAtc);
      return true;
    }

    var featuresControl = closest(target, '.c-product-explainer__nav-button, .c-product-explainer [data-carousel-prev], .c-product-explainer [data-carousel-next], .c-product-explainer .o-carousel-control');
    if (featuresControl) {
      publishWithPageMeta('product_features_carousel_scrolled', {
        element_type: 'control',
        element_action: controlAction(featuresControl),
        element_text: text(featuresControl),
        container_name: titleFromSection(getSection(featuresControl))
      }, featuresControl);
      return true;
    }

    var productTab = closest(target, '.c-product-main__detail-tabs button, .c-product-main__detail-tabs [role="tab"], .c-product-explainer__categories-btn, .c-product-explainer .c-categories__btn');
    if (productTab) {
      publishWithPageMeta('product_tab_clicked', {
        element_type: 'tab',
        element_action: 'select_tab',
        element_text: text(productTab),
        element_position: indexIn('button, [role="tab"], .c-categories__btn', productTab, closest(productTab, '.c-product-main, .c-product-explainer') || document),
        container_name: titleFromSection(getSection(productTab)),
        container_type: 'product_tabs'
      }, productTab);
      return true;
    }

    var videoOpen = closest(target, '.c-product-explainer__video, .c-product-main__tolstoy-wrap, .c-product-gallery [data-media-type="video"], .c-product-gallery video, [data-video-open], [data-video-pointer-toggle]');
    if (videoOpen) {
      publishWithPageMeta('product_video_opened', {
        element_type: 'video',
        element_action: 'open',
        element_text: text(videoOpen) || 'Product video',
        container_name: titleFromSection(getSection(videoOpen))
      }, videoOpen);
      return true;
    }

    var videoControl = closest(target, '.c-product-explainer video, .c-product-explainer [data-control], .c-product-explainer button[aria-label*="play" i], .c-product-explainer button[aria-label*="pause" i], .c-product-explainer button[aria-label*="mute" i], .c-product-main video, .c-product-main [data-control]');
    if (videoControl) {
      publishWithPageMeta('product_video_interacted', {
        element_type: 'video_control',
        element_action: controlAction(videoControl),
        element_text: text(videoControl),
        container_name: titleFromSection(getSection(videoControl))
      }, videoControl);
      return true;
    }

    var bundle = closest(target, '.c-product-main__bundle-upsell-cta, .c-product-main__bundle-upsell-icon, .c-product-main__bundle-upsell-accordion-header, .c-product-main__bundle-upsell a[href], .c-product-main__bundle-upsell button');
    if (bundle) {
      publishWithPageMeta('product_bundle_upgrade_clicked', merge({
        element_type: closest(bundle, '.c-product-main__bundle-upsell-cta')
          ? 'cta'
          : closest(bundle, '.c-product-main__bundle-upsell-icon')
            ? 'add_icon'
            : closest(bundle, '.c-product-main__bundle-upsell-accordion-header')
              ? 'accordion'
              : 'product_link',
        element_action: closest(bundle, '.c-product-main__bundle-upsell-accordion-header') ? 'expand_collapse' : 'click',
        element_text: text(bundle),
        bundle_name: text(document.querySelector('.c-product-main__bundle-upsell-title')),
        bundle_id: ''
      }, hrefData(bundle)), bundle);
      return true;
    }

    var flawless = closest(target, '.c-product-main__complementary-products a[href], .c-product-main__complementary-products button, .c-product-main__complementary-products .o-product-thumbnail__shade-swatch');
    if (flawless) {
      var flawlessPayload = productPayload(flawless);
      flawlessPayload.container_name = 'For flawless results';
      publishWithPageMeta('product_flawless_results_clicked', flawlessPayload, flawless);
      return true;
    }

    var behindBrandCta = closest(target, '.c-product-explainer a[href], .c-product-explainer .o-btn');
    if (behindBrandCta) {
      publishWithPageMeta('product_behind_brand_cta_clicked', merge({
        element_type: 'cta',
        element_text: text(behindBrandCta),
        container_name: 'Behind the brand'
      }, hrefData(behindBrandCta)), behindBrandCta);
      return true;
    }

    var reviewsClick = closest(target, '.c-product-reviews, .c-product-reviews__widget, [data-product-reviews-widget], [data-bv-show="reviews"], .bv_main_container, .bv-content-list, .bv-action-bar');
    if (reviewsClick && closest(reviewsClick, '.c-product-reviews, [data-product-reviews-widget]')) {
      publishWithPageMeta('product_reviews_interacted', {
        element_type: 'review_widget',
        element_action: text(target) || target.tagName.toLowerCase(),
        element_text: text(target),
        section_name: 'Reviews',
        section_type: 'product_reviews'
      }, reviewsClick);
      return true;
    }

    var recommendation = closest(target, '.c-related-products .o-product-thumbnail a[href], .c-related-products .o-product-card a[href], .c-related-products [data-product-card] a[href], .c-related-products button, .c-related-products .o-product-thumbnail__shade-swatch, .c-related-products [class*="swatch"]');
    if (recommendation) {
      var recPayload = productPayload(recommendation);
      recPayload.container_name = 'You may also like';
      publishWithPageMeta('product_recommendation_clicked', recPayload, recommendation);
      return true;
    }

    return false;
  }

  function handleBlogPageClick(target) {
    if (pageType() !== 'blog') return false;

    var hero = closest(target, '.c-mini-hero-banner a[href], .c-mini-hero-banner button');
    if (hero) {
      publishWithPageMeta('blog_hero_interacted', merge({
        element_type: matches(hero, 'button') ? 'control' : 'cta',
        element_action: matches(hero, 'button') ? controlAction(hero) : 'click',
        element_text: text(hero),
        container_name: 'Blog hero'
      }, hrefData(hero)), hero);
      return true;
    }

    var featured = closest(target, '.c-featured-blog-tile a[href], .c-featured-blog-tile__inner');
    if (featured) {
      var fp = articlePayload(featured);
      fp.element_type = articleClickType(target);
      fp.article_position = 'featured';
      fp.container_name = 'Featured article';
      publishWithPageMeta('blog_featured_article_clicked', fp, featured);
      return true;
    }

    var category = closest(target, '.c-blog-filters .c-categories__btn');
    if (category) {
      publishWithPageMeta('blog_category_clicked', merge({
        element_type: 'tab',
        element_action: 'select_tab',
        element_text: text(category),
        element_position: indexIn('.c-blog-filters .c-categories__btn', category, closest(category, '.c-categories') || document),
        category_id: category.getAttribute('data-category-id') || '',
        container_name: 'Blog categories',
        container_type: 'blog_categories'
      }, hrefData(category)), category);
      return true;
    }

    var categoryScroller = closest(target, '.c-blog-filters .c-categories__progress, .c-blog-filters [data-categories-scroll]');
    if (categoryScroller) {
      publishWithPageMeta('blog_category_scroll_interacted', {
        element_type: 'category_scroller',
        element_action: 'click',
        element_text: text(categoryScroller),
        container_name: 'Blog categories',
        container_type: 'blog_categories'
      }, categoryScroller);
      return true;
    }

    var article = closest(target, '.c-blog-list .c-home-featured-journal__article-link');
    if (article) {
      var ap = articlePayload(article);
      ap.element_type = articleClickType(target);
      ap.container_name = 'Article grid';
      publishWithPageMeta('blog_article_clicked', ap, article);
      return true;
    }

    var pagination = closest(target, '.o-pagination__link');
    if (pagination && closest(pagination, '.c-blog-list')) {
      var label = text(pagination) || pagination.getAttribute('aria-label') || '';

      publishWithPageMeta('blog_pagination_clicked', merge({
        element_type: 'pagination',
        element_action: /prev/i.test(label) ? 'previous' : /next/i.test(label) ? 'next' : 'select_page',
        element_text: label,
        page_number: (text(pagination).match(/\d+/) || [''])[0],
        container_name: 'Blog pagination'
      }, hrefData(pagination)), pagination);
      return true;
    }

    var faqAccordion = closest(target, '.c-plp-faq summary, .c-plp-faq [data-accordion-title], .c-plp-faq__question');
    if (faqAccordion) {
      var details = closest(faqAccordion, 'details');

      publishWithPageMeta('blog_faq_accordion_clicked', {
        element_type: 'accordion',
        element_action: details && details.open ? 'collapse' : 'expand',
        element_text: text(faqAccordion),
        container_name: 'FAQ'
      }, faqAccordion);
      return true;
    }

    var faqLink = closest(target, '.c-plp-faq a[href]');
    if (faqLink) {
      publishWithPageMeta('blog_faq_link_clicked', merge({
        element_type: 'link',
        element_text: text(faqLink),
        container_name: 'FAQ'
      }, hrefData(faqLink)), faqLink);
      return true;
    }

    return false;
  }

  function handleArticlePageClick(target) {
    if (pageType() !== 'article') return false;

    var share = closest(target, '.c-article-hero__share-button, [data-copy-url]');
    if (share) {
      publishWithPageMeta('article_share_clicked', {
        element_type: 'share',
        element_action: 'copy_link',
        element_text: text(share) || 'Share',
        element_url: share.getAttribute('data-share-url') || window.location.href,
        element_url_full: absoluteUrl(share.getAttribute('data-share-url') || window.location.href)
      }, share);
      return true;
    }

    var featuredAdd = closest(target, '.c-main-article__featured-product [data-product-quick-add], .c-main-article__featured-product .o-product-thumbnail__add-btn, .c-main-article__featured-product button[name="add"], .c-main-article__featured-product form[action*="/cart/add"] button[type="submit"]');
    if (featuredAdd) {
      var featuredAtc = productPayload(featuredAdd);
      featuredAtc.container_name = 'Featured product';
      featuredAtc.element_type = 'add_to_cart';
      featuredAtc.element_action = 'add_to_cart';

      publishWithPageMeta('article_featured_product_add_to_cart_clicked', featuredAtc, featuredAdd);
      return true;
    }

    var featuredProduct = closest(target, '.c-main-article__featured-product a[href], .c-main-article__featured-product .o-product-card, .c-main-article__featured-product [class*="swatch"]');
    if (featuredProduct) {
      var fp = productPayload(featuredProduct);
      fp.container_name = 'Featured product';

      publishWithPageMeta('article_featured_product_clicked', fp, featuredProduct);
      return true;
    }

    var relatedControl = closest(target, '.c-related-articles [data-carousel-prev], .c-related-articles [data-carousel-next], .c-related-articles .o-carousel-control, .c-related-articles button[aria-label*="Previous" i], .c-related-articles button[aria-label*="Next" i]');
    if (relatedControl) {
      publishWithPageMeta('article_related_articles_control_clicked', {
        element_type: 'control',
        element_action: controlAction(relatedControl),
        element_text: text(relatedControl),
        container_name: 'Related articles'
      }, relatedControl);
      return true;
    }

    var relatedArticle = closest(target, '.c-related-articles a[href]');
    if (relatedArticle) {
      var rp = articlePayload(relatedArticle);
      rp.element_type = articleClickType(target);
      rp.container_name = 'Related articles';

      publishWithPageMeta('article_related_article_clicked', rp, relatedArticle);
      return true;
    }

    var bodyImage = closest(target, '.c-main-article__content a[href] picture, .c-main-article__content a[href] img');
    if (bodyImage) {
      var imageLink = closest(bodyImage, 'a[href]');

      publishWithPageMeta('article_image_clicked', merge({
        element_type: 'image',
        element_text: text(bodyImage) || (bodyImage.getAttribute && bodyImage.getAttribute('alt')) || '',
        element_position: indexIn('.c-main-article__content img, .c-main-article__content picture', bodyImage, document),
        container_name: 'Article body'
      }, hrefData(imageLink)), bodyImage);
      return true;
    }

    var bodyLink = closest(target, '.c-main-article__content a[href]');
    if (bodyLink) {
      publishWithPageMeta('article_body_link_clicked', merge({
        element_type: closest(bodyLink, '.o-btn') ? 'cta' : 'link',
        element_text: text(bodyLink),
        element_position: indexIn('.c-main-article__content a[href]', bodyLink, document),
        container_name: 'Article body'
      }, hrefData(bodyLink)), bodyLink);
      return true;
    }

    return false;
  }

  function handleAboutClick(target) {
    if (pageType() !== 'about') return false;

    var hero = closest(target, '.c-hero-banner-carousel a[href], .c-hero-banner-carousel button');
    if (hero) {
      publish('about_hero_interacted', merge({
        element_type: matches(hero, 'button') ? 'control' : 'cta',
        element_action: matches(hero, 'button') ? controlAction(hero) : 'click',
        element_text: text(hero),
        container_name: titleFromSection(getSection(hero))
      }, hrefData(hero)), hero);
      return true;
    }

    var accordion = closest(target, '.c-text-image__accordion-header');
    if (accordion) {
      var details = closest(accordion, 'details');

      publish('about_text_image_accordion_clicked', {
        element_type: 'accordion',
        element_action: details && details.open ? 'collapse' : 'expand',
        element_text: text(accordion),
        container_name: titleFromSection(getSection(accordion))
      }, accordion);
      return true;
    }

    var storyRead = closest(target, '.c-story-carousel__button-read-more, .c-story-carousel__button-shrink');
    if (storyRead) {
      publish('about_story_read_more_clicked', {
        element_type: 'button',
        element_action: closest(storyRead, '.c-story-carousel__button-shrink') ? 'collapse' : 'expand',
        element_text: text(storyRead),
        container_name: titleFromSection(getSection(storyRead))
      }, storyRead);
      return true;
    }

    var storyControl = closest(target, '.c-story-carousel__slides-nav button, .c-story-carousel [data-carousel-prev], .c-story-carousel [data-carousel-next], .c-story-carousel .o-carousel-control');
    if (storyControl) {
      publish('about_story_carousel_control_clicked', {
        element_type: 'control',
        element_action: controlAction(storyControl),
        element_text: text(storyControl),
        container_name: titleFromSection(getSection(storyControl))
      }, storyControl);
      return true;
    }

    var flipCard = closest(target, '.c-flip-cards__flip-btn, .c-flip-cards__card');
    if (flipCard) {
      publish('about_flip_card_clicked', {
        element_type: 'flip_card',
        element_action: closest(flipCard, '.c-flip-cards__flip-btn--back') ? 'close' : 'flip',
        element_text: text(flipCard),
        element_position: indexIn('.c-flip-cards__slide, .c-flip-cards__card', closest(flipCard, '.c-flip-cards__slide, .c-flip-cards__card'), closest(flipCard, '.c-flip-cards') || document),
        container_name: titleFromSection(getSection(flipCard))
      }, flipCard);
      return true;
    }

    var flipControl = closest(target, '.c-flip-cards__nav-button, .c-flip-cards [data-carousel-prev], .c-flip-cards [data-carousel-next]');
    if (flipControl) {
      publish('about_flip_cards_carousel_control_clicked', {
        element_type: 'control',
        element_action: controlAction(flipControl),
        element_text: text(flipControl),
        container_name: titleFromSection(getSection(flipControl))
      }, flipControl);
      return true;
    }

    var marquee = closest(target, '.c-marquee__control');
    if (marquee) {
      publish('about_marquee_control_clicked', {
        element_type: 'control',
        element_action: 'play_pause',
        element_text: text(marquee),
        container_name: titleFromSection(getSection(marquee))
      }, marquee);
      return true;
    }

    return false;
  }

  function handleCartDrawerClick(target) {
    var cart = getCartDrawer();
    if (!cart || !closest(target, '#rebuy-cart')) return false;

    var close = closest(target, '.rebuy-cart__flyout-close, .rebuy-cart__background');
    if (close) {
      publish('cart_drawer_closed', cartBase({
        element_type: 'drawer',
        element_action: 'close',
        element_text: text(close) || 'Close Cart'
      }), close);
      return true;
    }

    var announcement = closest(target, '#rebuy-smart-cart-announcement-bar, .rebuy-cart__flyout-announcement-bar-message');
    if (announcement) {
      publish('cart_drawer_announcement_interacted', cartBase({
        element_type: 'announcement_bar',
        element_action: 'click',
        element_text: text(announcement),
        element_position: indexIn('.rebuy-cart__flyout-announcement-bar-message', closest(announcement, '.rebuy-cart__flyout-announcement-bar-message'), closest(announcement, '#rebuy-smart-cart-announcement-bar') || document)
      }), announcement);
      return true;
    }

    var progress = closest(target, '.rebuy-cart__progress-bar-container, .rebuy-cart__progress-bar-meter, .rebuy-cart__progress-bar-prompt');
    if (progress) {
      var fill = cart.querySelector('.rebuy-cart__progress-bar-meter-fill');

      publish('cart_drawer_progress_bar_clicked', cartBase({
        element_type: 'progress_bar',
        element_action: 'click',
        element_text: text(progress),
        progress_value: fill ? fill.getAttribute('aria-valuenow') || '' : ''
      }), progress);
      return true;
    }

    var remove = closest(target, '.rebuy-cart__flyout-item-remove');
    if (remove) {
      publish('cart_drawer_item_removed', merge(getCartLineItemPayload(remove), {
        element_type: 'remove',
        element_action: 'remove_item',
        element_text: text(remove) || remove.getAttribute('aria-label') || ''
      }), remove);
      return true;
    }

    var qty = closest(target, '.rebuy-cart__flyout-item-quantity-widget-button');
    if (qty) {
      var aria = qty.getAttribute('aria-label') || '';
      var action = /decrease|minus/i.test(aria + ' ' + text(qty)) ? 'decrease' : 'increase';

      publish('cart_drawer_quantity_clicked', merge(getCartLineItemPayload(qty), {
        element_type: 'quantity',
        element_action: action,
        element_text: text(qty) || aria
      }), qty);
      return true;
    }

    var lineItemLink = closest(target, '.rebuy-cart__flyout-item-media a[href], .rebuy-cart__flyout-item-product-title[href]');
    if (lineItemLink) {
      publish('cart_drawer_item_clicked', merge(getCartLineItemPayload(lineItemLink), {
        element_type: closest(lineItemLink, '.rebuy-cart__flyout-item-media') ? 'image' : 'title'
      }), lineItemLink);
      return true;
    }

    var recNav = closest(target, '.rebuy-widget .flickity-prev-next-button, .rebuy-widget .dot');
    if (recNav) {
      publish('cart_drawer_recommendation_nav_clicked', cartBase({
        element_type: 'control',
        element_action: controlAction(recNav),
        element_text: text(recNav),
        container_name: text(closest(recNav, '.rebuy-widget') && closest(recNav, '.rebuy-widget').querySelector('.primary-title')),
        container_type: 'cart_recommendations'
      }), recNav);
      return true;
    }

    var recAdd = closest(target, '.rebuy-product-block .rebuy-button');
    if (recAdd) {
      var recAtc = productPayload(recAdd);
      recAtc.element_type = 'add_to_cart';
      recAtc.element_action = 'add_recommendation';
      recAtc.container_type = 'cart_recommendations';

      publish('cart_drawer_recommendation_add_clicked', cartBase(recAtc), recAdd);
      return true;
    }

    var recLink = closest(target, '.rebuy-product-block a[href]');
    if (recLink) {
      var rec = productPayload(recLink);
      rec.container_type = 'cart_recommendations';

      publish('cart_drawer_recommendation_clicked', cartBase(rec), recLink);
      return true;
    }

    var discountApply = closest(target, '.rebuy-cart__flyout-discount-form .rebuy-button');
    if (discountApply) {
      publish('cart_drawer_discount_apply_clicked', cartBase({
        element_type: 'button',
        element_action: 'apply_discount',
        element_text: text(discountApply),
        form_name: 'cart_discount'
      }), discountApply);
      return true;
    }

    var checkout = closest(target, '.rebuy-cart__checkout-button');
    if (checkout) {
      publish('cart_drawer_checkout_clicked', cartBase({
        element_type: 'checkout',
        element_action: 'begin_checkout',
        element_text: text(checkout)
      }), checkout);
      return true;
    }

    var powered = closest(target, '.powered-by-rebuy a[href]');
    if (powered) {
      publish('cart_drawer_rebuy_link_clicked', merge(cartBase({
        element_type: 'external_link',
        element_text: text(powered)
      }), hrefData(powered)), powered);
      return true;
    }

    return false;
  }

  function handleNewsletterChatSocialFooter(target) {
    var newsletterHandle = closest(
      target,
      '[class*="newsletter"] button, [class*="newsletter"] a, [aria-label*="newsletter" i], [aria-label*="subscribe" i], .klaviyo-form button, .needsclick button'
    );
    if (newsletterHandle) {
      publish('newsletter_modal_handle_clicked', {
        element_type: matches(newsletterHandle, 'button') ? 'button' : 'link',
        element_action: 'click',
        element_text: text(newsletterHandle)
      }, newsletterHandle);
      return true;
    }

    var chatLauncher = closest(
      target,
      '[id*="gorgias" i], [class*="gorgias" i], iframe[src*="gorgias" i], [aria-label*="chat" i], [aria-label*="help" i], [class*="chat" i]'
    );
    if (chatLauncher) {
      publish('chat_widget_open_clicked', {
        element_type: 'chat_launcher',
        element_action: 'open',
        element_text: text(chatLauncher)
      }, chatLauncher);
      return true;
    }

    var socialLink = closest(
      target,
      '.c-insta-gallery__social-link, .c-footer__social a[href], a[href*="instagram.com"], a[href*="facebook.com"], a[href*="tiktok.com"], a[href*="youtube.com"], a[href*="pinterest.com"]'
    );
    if (socialLink) {
      publish('social_link_clicked', merge({
        element_type: 'social_link',
        element_text: text(socialLink),
        container_name: titleFromSection(getSection(socialLink))
      }, hrefData(socialLink)), socialLink);
      return true;
    }

    var footerItem = closest(target, '.c-footer a[href], .c-footer button, .c-footer summary');
    if (footerItem) {
      publish('footer_item_clicked', merge({
        element_type: matches(footerItem, 'summary') ? 'accordion' : matches(footerItem, 'button') ? 'button' : 'link',
        element_text: text(footerItem),
        element_position: indexIn('.c-footer a[href], .c-footer button, .c-footer summary', footerItem, closest(footerItem, '.c-footer') || document),
        container_name: text(closest(footerItem, '.c-footer__accordion-item, .c-footer__links, .c-footer__secondary-menu, .c-footer__newsletter'))
      }, hrefData(footerItem)), footerItem);
      return true;
    }

    return false;
  }

  function handleGenericPageLinks(target) {
    var link = closest(target, '#MainContent a[href], #MainContent button');

    if (!link) return false;

    var eventName = '';

    if (pageType() === 'about') eventName = 'about_page_link_clicked';
    else if (pageType() === 'blog') eventName = 'blog_page_link_clicked';
    else if (pageType() === 'article') eventName = 'article_page_link_clicked';

    if (!eventName) return false;

    publishWithPageMeta(eventName, merge({
      element_type: matches(link, 'button') ? 'button' : 'link',
      element_text: text(link),
      element_position: indexIn('#MainContent a[href], #MainContent button', link, document),
      container_name: titleFromSection(getSection(link))
    }, hrefData(link)), link);

    return true;
  }

  function clickHandler(event) {
    var target = event.target;

    if (handleCartDrawerClick(target)) return;
    if (handleCollectionClick(target)) return;
    if (handleProductPageClick(target)) return;
    if (handleBlogPageClick(target)) return;
    if (handleArticlePageClick(target)) return;
    if (handleAboutClick(target)) return;
    if (handleHomepageClick(target)) return;
    if (handleProductCarouselClick(target)) return;
    if (handleProductInsertClick(target)) return;
    if (handleVideoAndBlogHomepageClick(target)) return;
    if (handleNewsletterChatSocialFooter(target)) return;
    if (handleGenericPageLinks(target)) return;
  }

  function fieldHandler(event) {
    var target = event.target;

    var newsletterField = closest(
      target,
      '.klaviyo-form input, .klaviyo-form textarea, .klaviyo-form select, .needsclick input, .needsclick textarea, .needsclick select, [class*="newsletter"] input, [class*="newsletter"] textarea, [class*="newsletter"] select'
    );

    if (newsletterField) {
      var newsletterKey = ['newsletter', newsletterField.name || newsletterField.id || newsletterField.type || 'field', event.type, window.location.pathname].join('|');

      if (!fieldInteractionCache[newsletterKey]) {
        fieldInteractionCache[newsletterKey] = true;

        publish('newsletter_modal_field_interacted', {
          element_type: 'form_field',
          element_action: event.type,
          element_text: newsletterField.name || newsletterField.id || newsletterField.type || '',
          field_type: newsletterField.type || newsletterField.tagName.toLowerCase(),
          form_name: text(closest(newsletterField, 'form')) || 'newsletter'
        }, newsletterField);
      }
    }

    var discountField = closest(target, '#rebuy-discount-input, .rebuy-cart__flyout-discount-form input');

    if (discountField && closest(discountField, '#rebuy-cart')) {
      var discountKey = event.type + '|cart_discount';

      if (!fieldInteractionCache[discountKey]) {
        fieldInteractionCache[discountKey] = true;

        publish('cart_drawer_discount_field_interacted', cartBase({
          element_type: 'form_field',
          element_action: event.type,
          element_text: 'Discount Code',
          field_type: discountField.type || 'text',
          form_name: 'cart_discount'
        }), discountField);
      }
    }
  }

  function submitHandler(event) {
    var form = closest(event.target, '.klaviyo-form form, .needsclick form, [class*="newsletter"] form, form[data-newsletter-signup]');

    if (!form) return;

    publish('newsletter_modal_form_submitted', {
      element_type: 'form',
      element_action: 'submit',
      element_text: text(form) || form.id || 'newsletter_form',
      form_name: form.id || form.getAttribute('name') || 'newsletter'
    }, form);
  }

  function messageHandler(event) {
    var origin = event.origin || '';
    var dataString = '';

    try {
      dataString = typeof event.data === 'string' ? event.data : JSON.stringify(event.data || {});
    } catch (e) {
      dataString = '';
    }

    if (/gorgias|chat/i.test(origin + ' ' + dataString)) {
      publish('chat_widget_interacted', {
        element_type: 'chat_widget',
        element_action: 'message',
        element_text: 'chat interaction',
        event_source: sanitize(origin, 120)
      }, document.body);
    }
  }

  function videoEventHandler(event) {
    var video = event.target;

    if (!matches(video, 'video')) return;

    var pt = pageType();
    var eventName = '';

    if (pt === 'product') eventName = 'product_video_interacted';
    else if (pt === 'about') eventName = 'about_video_interacted';
    else if (pt === 'homepage') eventName = 'video_section_control_clicked';

    if (!eventName) return;

    publishWithPageMeta(eventName, {
      element_type: 'video_control',
      element_action: event.type === 'volumechange' ? 'mute_sound' : event.type,
      element_text: pt + ' video ' + event.type,
      container_name: titleFromSection(getSection(video))
    }, video);
  }

  function sectionViewedEventName() {
    var pt = pageType();

    if (pt === 'homepage') return 'homepage_section_viewed';
    if (pt === 'collection') return 'collection_section_viewed';
    if (pt === 'product') return 'product_section_viewed';
    if (pt === 'about') return 'about_section_viewed';
    if (pt === 'blog') return 'blog_section_viewed';
    if (pt === 'article') return 'article_section_viewed';

    return '';
  }

  function initSectionViews() {
    var eventName = sectionViewedEventName();

    if (!eventName || !('IntersectionObserver' in window)) return;

    var selectors = '#MainContent .shopify-section, #MainContent section, .shopify-section.c-section';

    if (pageType() === 'article') {
      selectors += ', .c-main-article__content';
    }

    var sections = Array.prototype.slice.call(document.querySelectorAll(selectors));

    if (!sections.length) return;

    var visibleTimers = {};

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var section = entry.target;
          var id = section.id || getSectionType(section) || String(indexIn(selectors, section, document));

          if (!id || viewedSections[eventName + '|' + id]) return;

          if (entry.isIntersecting && entry.intersectionRatio >= VIEW_THRESHOLD) {
            visibleTimers[id] = window.setTimeout(function () {
              if (viewedSections[eventName + '|' + id]) return;

              viewedSections[eventName + '|' + id] = true;

              publishWithPageMeta(eventName, {
                event_category: 'engagement',
                element_type: 'section',
                element_action: 'view',
                section_name: titleFromSection(section) || (matches(section, '.c-main-article__content') ? 'Article body' : ''),
                section_type: getSectionType(section) || (matches(section, '.c-main-article__content') ? 'article_body' : ''),
                section_id: section.id || '',
                element_position: indexIn(selectors, section, document)
              }, section);

              observer.unobserve(section);
            }, VIEW_MIN_MS);
          } else if (visibleTimers[id]) {
            window.clearTimeout(visibleTimers[id]);
            visibleTimers[id] = null;
          }
        });
      },
      { threshold: [VIEW_THRESHOLD] }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function observeCartDrawer() {
    var cart = getCartDrawer();

    if (!cart) return;

    publishCartViewedIfVisible();

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      if (!isCartDrawerVisible(cart)) {
        cartDrawerViewed = false;
        return;
      }

      publishCartViewedIfVisible();
    });

    observer.observe(cart, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'style']
    });
  }

  function init() {
    document.addEventListener('click', clickHandler, true);
    document.addEventListener('focusin', fieldHandler, true);
    document.addEventListener('change', fieldHandler, true);
    document.addEventListener('submit', submitHandler, true);
    window.addEventListener('message', messageHandler, false);

    ['play', 'pause', 'volumechange'].forEach(function (eventName) {
      document.addEventListener(eventName, videoEventHandler, true);
    });

    initSectionViews();
    observeCartDrawer();

    log('[GA4 custom events] Tracking hooks initialised');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();